import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../lib/analytics";

// Scroll to top + emit GTM page_view on every client-side navigation.
const ScrollToTop: React.FC = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
    // Defer page_view to the next frame so <title> (from Helmet) has updated.
    const id = window.setTimeout(() => {
      trackPageView(pathname + search);
    }, 50);
    return () => window.clearTimeout(id);
  }, [pathname, search]);

  return null;
};

export default ScrollToTop;
